import { ReactNode } from "react";

import { twMerge } from "tailwind-merge";

type MailToProps = {
  email: string;
  subject?: string;
  body?: string;
  className?: string;
  /** Link label. Defaults to the email address. */
  children?: ReactNode;
};

function MailTo({
  email,
  subject = "",
  body = "",
  className,
  children
}: Readonly<MailToProps>) {
  const href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={twMerge(
        "text-[12px] font-semibold text-txtBody hover:text-blue-600",
        className
      )}
    >
      {children ?? email}
    </a>
  );
}

export default MailTo;
